import axios from "axios";
import { clearStorage, retrieveToken } from "utils/storage";
import AlertNotification from "components/CustomWidgets/alertNotification";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = retrieveToken("accessToken");
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const deviceId = retrieveToken("deviceId");

    config.headers = {
      ...config.headers,
      "X-Platform": "1",
      timezone: timezone,
    };

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (deviceId) {
      config.headers["X-DeviceId"] = deviceId;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (res) => {
    // ✅ Handle app-level errors (success: false)
    if (res.data && res.data.success === false) {
      // Optionally notify user
      AlertNotification("error", res.data.message || "Something went wrong");

      // Reject this so React Query treats it as error
      return Promise.reject(new Error(res.data.message || "App error"));
    }

    return res;
  },
  (error) => {
    const status = error.response?.status;
   if (status === 401) {
      const message = error.response?.data?.message || "Session expired. Please login again.";

      if (retrieveToken("accessToken")) {
        AlertNotification("error", message);
        clearStorage();
        if (window.location.pathname !== "/login") {
          setTimeout(() => {
            window.location.href = "/login";
          }, 1500);
        }
      }
      return Promise.resolve();
    }


    if (status === 403 || status === 500 || error.message === "Network Error") {
      clearStorage();
      window.location.href = "/login";
      return Promise.resolve(); // prevents unhandled error
    }

    AlertNotification(
      "error",
      error.response?.data?.message || "Something went wrong",
    );

    return Promise.reject(error);
  },
);

export default api;
